import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { list, create } from 'actions/data'
import { Dialog, DialogActions, Tooltip, withStyles } from '@material-ui/core'
import Button from 'components/theme/Button'
import { selectUser } from 'actions/users'
import { ArrowLeft, Cancel, Email, Phone, Person } from '@material-ui/icons'
import { ShieldAccount } from 'mdi-material-ui'
import { LoginVariant } from 'mdi-material-ui'
import { userSignOut } from 'actions/auth'
import Permissions from './Permissions'
// import { DATA_API_URL } from 'utils/AllURLs'

const urlParams = new URLSearchParams(window.location.search)
const jwtToken = urlParams.get('jwtToken')

const styles = theme => ({
  container: {
    position: 'relative',
    padding: '45px 120px',
    [theme.breakpoints.down('sm')]: {
      padding: '45px 0',
    },
  },
})

class TransferDialog extends Component {
  state = { input: '' }

  render() {
    return (
      <Dialog
        open={this.props.open}
        maxWidth="sm"
        PaperProps={{
          style: {
            borderRadius: 22,
            padding: 20,
          },
        }}
      >
        <div
          style={{
            fontSize: 20,
            fontWeight: 'bold',
            color: '#014c94',
            marginBottom: 5,
          }}
        >
          <LoginVariant style={{ marginRight: 5 }} />
          ACCOUNT OWNERSHIP TRANSFER
        </div>
        <div style={{ marginBottom: 5 }}>
          You are about to transfer account ownership to{' '}
          <span style={{ color: '#014c94', fontWeight: 'bold' }}>
            {this.props.name}
          </span>
          . Please read below to make sure you are aware of the consequences of
          doing so.
          <ul>
            <li>
              You will lose complete ownership of this account, including access
              to billing and ownership admin rights.
            </li>
            <li>You will be reverted to a regular user with full access.</li>
            <li>
              This action can{' '}
              <span style={{ color: '#014c94', fontWeight: 'bold' }}>NOT</span>
            </li>{' '}
            be undone.
          </ul>
          Please enter the{' '}
          <span style={{ color: '#014c94', fontWeight: 'bold' }}>FULL</span>{' '}
          name of the user,{' '}
          <span style={{ color: '#014c94', fontWeight: 'bold' }}>
            {this.props.name}
          </span>
          , then press{' '}
          <span style={{ color: '#014c94', fontWeight: 'bold' }}>CONFIRM</span>{' '}
          to transfer account ownership.
        </div>
        <input
          value={this.state.input}
          onChange={e =>
            e &&
            e.target &&
            typeof e.target.value === 'string' &&
            this.setState({ input: e.target.value })
          }
          style={{
            borderRadius: 35,
            border: '1px solid gray',
            fontSize: 16,
            padding: 5,
            marginBottom: 5,
          }}
        />
        <div style={{ marginBottom: 5 }}>
          <Button
            color="secondary"
            variant="outlined"
            style={{ marginBottom: 5 }}
            disabled={
              this.state.input.toLowerCase() !== this.props.name.toLowerCase()
            }
            onClick={() => this.props.transfer()}
          >
            Confirm account ownership transfer to {this.props.name}
          </Button>
        </div>
        <DialogActions>
          <Button
            color="secondary"
            variant="outlined"
            onClick={() => this.props.close()}
          >
            <Cancel style={{ marginRight: 5 }} />
            Cancel
          </Button>
        </DialogActions>
      </Dialog>
    )
  }
}

class UserPage extends Component {
  state = { transferDialogOpen: false }

  componentDidMount() {
    this.props.list('account/user', 'user_name')
    // this.props.list(
    //   'screenpermissions',
    //   null,
    //   `${DATA_API_URL}/screenpermissions`,
    // )
  }

  signOut = () => {
    jwtToken
      ? window.ReactNativeWebView &&
        window.ReactNativeWebView.postMessage('signout')
      : this.props.userSignOut()
  }

  render() {
    const {
      user,
      create,
      currentUsername,
      selectUser,
      vr_role,
      modal,
      classes,
    } = this.props

    const username = user && user.user_name

    return (
      <div className={classes.container}>
        {modal && (
          <div style={{ position: 'absolute', top: 0, left: 0 }}>
            <Button
              color="secondary"
              variant="outlined"
              onClick={() => selectUser(null)}
            >
              <ArrowLeft style={{ marginRight: 5 }} />
              Back
            </Button>
          </div>
        )}
        <div style={{ textAlign: 'left' }}>
          <div style={{ fontSize: 30, color: '#014c94' }}>
            {user.first_name} {user.last_name}
          </div>
          <div style={{ marginTop: 5 }}>
            <Email
              style={{
                marginRight: 5,
                color: '#014c94',
                verticalAlign: 'middle',
              }}
            />
            {user.email}
            {user.user_name === currentUsername && (
              <Button
                style={{ marginLeft: 12 }}
                onClick={() =>
                  this.props.create({
                    entity: null,
                    entityType: 'email/verify_my_address',
                    noReturnValue: true,
                    hasSchema: false,
                  })
                }
                variant="contained"
                color="primary"
                size="small"
              >
                {this.props?.['email/valid_sending_addresses']?.[user.email]
                  ?.status === 'success'
                  ? 'Re-send '
                  : 'Send '}
                verification email
              </Button>
            )}
          </div>
          <div style={{ marginTop: 5, marginBottom: 15 }}>
            <Phone
              style={{
                marginRight: 5,
                color: '#014c94',
                verticalAlign: 'middle',
              }}
            />
            {user.phone_number}
          </div>
          <div style={{ marginTop: 5, marginBottom: 15 }}>
            <Person
              style={{
                marginRight: 5,
                color: '#014c94',
                verticalAlign: 'middle',
              }}
            />
            {user.user_name}
          </div>
          <div style={{ marginTop: 5, marginBottom: 15 }}>
            <ShieldAccount
              style={{
                marginRight: 5,
                color: '#014c94',
                verticalAlign: 'middle',
              }}
            />
            Account role:{' '}
            {user.user_role === 'acctowner' ? 'account owner' : user.user_role}
          </div>
        </div>
        {username && vr_role === 'acctowner' && (
          <>
            <div
              style={{
                border: '1px solid gray',
                borderRadius: 20,
                textAlign: 'left',
                padding: 20,
              }}
            >
              <div
                style={{
                  fontSize: 20,
                  fontWeight: 'bold',
                  color: '#014c94',
                  marginBottom: 5,
                }}
              >
                <LoginVariant style={{ marginRight: 5 }} />
                ACCOUNT OWNERSHIP TRANSFER
              </div>
              <div style={{ marginBottom: 5 }}>
                You can transfer ownership to the user by clicking the button
                below and entering the name of the user for confirmation to
                complete the transfer.
              </div>
              <Tooltip
                title={
                  username === currentUsername
                    ? 'You are already the account owner'
                    : 'This will transfer account ownership to this user'
                }
              >
                <Button
                  color="secondary"
                  variant="outlined"
                  disabled={username === currentUsername}
                  onClick={() => this.setState({ transferDialogOpen: true })}
                >
                  {`Transfer account ownership to ${
                    user.first_name || username
                  }`}
                </Button>
              </Tooltip>
            </div>
            <TransferDialog
              name={`${user.first_name || ''} ${user.last_name || ''}`}
              open={this.state.transferDialogOpen}
              close={() => this.setState({ transferDialogOpen: false })}
              transfer={() =>
                create({
                  entity: { username },
                  entityType: 'account/user',
                  path: 'account/user/owner',
                  noReturnValue: true,
                }).then(() => this.signOut())
              }
            />
            <h3 style={{ color: '#014c94', textAlign: 'left' }}>
              Screen Permissions
            </h3>
            <Permissions username={username} />
            <div style={{ textAlign: 'left', color: 'gray', fontSize: 12 }}>
              Please note that these permissions only provide a visual feature
              that hides screens from the menu. It does not restrict API access
              or prevent direct navigation to those screens.
            </div>
          </>
        )}
      </div>
    )
  }
}

export default connect(
  (state, { match, username }) => {
    const un = username || (match && match.params && match.params.username)
    return {
      user:
        (un && state.data['account/user'] && state.data['account/user'][un]) ||
        {},
      currentUsername:
        state.auth.session &&
        state.auth.session.idToken &&
        state.auth.session.idToken.payload &&
        state.auth.session.idToken.payload['cognito:username'],
      vr_role:
        state.auth.session &&
        state.auth.session.idToken &&
        state.auth.session.idToken.payload &&
        state.auth.session.idToken.payload['custom:vr_role'],
      'email/valid_sending_addresses':
        state.data?.['email/valid_sending_addresses'],
    }
  },
  dispatch =>
    bindActionCreators({ list, create, selectUser, userSignOut }, dispatch),
)(withStyles(styles)(UserPage))
